import React, { useCallback, useContext, useEffect, useState } from "react";
import { AppContext } from "../../Context";
import { Autocomplete, Box, Button, Grid,  Stack, TextField, Typography } from "@mui/material";
import {
  VM_Colors,
  VM_ResponsiveBox,
  registrationStepShellSx,
} from "../../Styles/VMStyles";
import {  ADD_VENUE_DETAILS_BELOW, default_countryID, VENUE_REGISTRATION } from "../../Util/VMConstants";
import { getCountryCodeFromCountryID, getCurrencyFromCountryID, Venue_City, Venue_Country, Venue_State, Venue_Type,  VM_transformCountryList, VM_transformStatesList, VM_venueTypes } from "../../Helper/RegistrationHelper";
import useCountryList from "../../Hooks/useCountryList";
import TitleDesc from "../../Components/Custom/TitleDesc";
import MUITextFieldSelect from "../../Components/MUITextFieldSelect";
import ApiService, { postApi } from "../../Util/ApiService";
import {  API_ADD_CITY, API_CITIES,  API_STATES,  API_UPDATE_VENUE_REGISTRATION,  API_VENUE_INFO,  API_VENUE_REGISTRATION } from "../../Util/URLConstants";
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import AddPopUP from "../../Components/AddPopUP";
import MUITypography from "../../Components/MUITypography";
import { toast } from "react-toastify";
import { isEmpty, toTitleCaseInput } from "../../Util/UtilHelper";
import axios from "axios";
import Loader from "../../Components/Loader";
import StyledInputField from "../../Components/Custom/StyledInputField";
import MuiTypographyMandatory from "../../Components/Custom/MuiTypographyMandatory";
import FieldWrapper from "../../Components/Custom/FieldWrapper";

const formFieldSpacing = {
  mt: 2,
};

function VenueRegistration() {
  const [state,setState] = useState({
        countryID:default_countryID,
        countryCode:'',
        currency:'',
        venuemobileno:'',
        stateID :'',
        cityID:'',
        customVenueType:''
      });
  const [warning,setWarning] =useState({
    venueTypeError:false,
    venueCountryError:false,
    venueStateError:false,
    venueCityError:false
  })    
  
  const [statesList ,setStatesList] = useState([]);    
  const [citiesList ,setCitiesList] = useState([]);   
  const [newCity ,setNewCity] = useState("");   
  const [openDialog, setOpenDialog] = useState(false);
  const [loading,setLoading] = useState(false);
      
   
  const { formValues, handleChange, handleNext, variant } = useContext(AppContext);
  const { country } = useCountryList();

  const { venuename, venuetype, venuemobileno, venueemail,
    venuecountry, venuestate, venuecity, venueaddress, venuepincode, venuewebsiteurl ,businesslabel } = formValues;

  // const isError = useCallback(
  //   () =>
  //     Object.keys({
  //       venuename, venuetype, venuemobileno, venueemail, venueCurrency,
  //       venuecountry, venuestate, venuecity, venueaddress, venuepincode, venuewebsiteurl
  //     }).some((name) => (
  //       (formValues[name].required && !formValues[name].value) || formValues[name].error
  //     )),
  //   [formValues]
  // );

  useEffect(() => {
    async function fetchStates() {
      if (!state.countryID) return;
      setStatesList([]);
      setLoading(true);
      try {
        const data = await ApiService.getApi(API_STATES + state.countryID);
        setStatesList(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching states:", error);
        setLoading(false);
      }
    }
    fetchStates();
  }, [state.countryID]);


  useEffect(() => {
    async function fetchVenueInfo() {
      setLoading(true)
      try {
        const resp = await axios.get(API_VENUE_INFO + "?user_id="+formValues.user_id);
        const respData = resp.data;
        if (respData?.status_code === 200) {
          setLoading(false);
          const venue_info = respData.venue_info[0];
          formValues.user_id = venue_info.user_id;
          formValues.venue_id = venue_info.venue_id;
          formValues.venuename.value = venue_info.venue_name;

          const allVenueTypes = VM_venueTypes.map(item => item.label);
          if(allVenueTypes.includes(venue_info.venue_type)){
            formValues.venuetype.value  = venue_info.venue_type;
            // setState({...state,customVenueType:''})
          }else{
            formValues.venuetype.value  = "Others";
            // setState({...state,customVenueType:venue_info.venue_type})
          }
           setState((prev) => ({...prev,
                      countryCode:venue_info.country_code, 
                      currency:venue_info.currency,
                      countryID:venue_info.country ,
                      stateID : venue_info.state,
                      cityID  : venue_info.city,
                      customVenueType:venue_info.venue_type,
                      venuemobileno : venue_info.venue_mobile_no,
                    }))
          formValues.venuemobileno.value = venue_info.venue_mobile_no;
          formValues.venueemail.value = venue_info.venue_email;
          formValues.venueaddress.value = venue_info.address;
          formValues.venuepincode.value = venue_info.pincode;
          formValues.businesslabel.value = venue_info.business_label;
          formValues.venuewebsiteurl.value = venue_info.website_url;
          formValues.venuecountry.value = venue_info.country;
          formValues.venuestate.value = venue_info.state;
          
        } else {
          toast.error(respData.message);
        }
      } catch (error) {
        setLoading(false)
        console.error("Venue Info Error:", error);
      }
    }
    fetchVenueInfo();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchCities = useCallback(async () => {
    try {
      setLoading(true);
      const data = await ApiService.getApi(API_CITIES + state.stateID);
      setLoading(false);
      setCitiesList(data);
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  }, [state.stateID]);

  useEffect(() => {
    if (state.stateID) fetchCities();
  }, [state.stateID, fetchCities]);

  useEffect(() => {
    if (citiesList.length > 0 && state.cityID) {
      const matched = citiesList.find((c) => String(c.id) === String(state.cityID));
      if (matched) formValues.venuecity.value = matched.city;
    }
  }, [citiesList, formValues.venuecity, state.cityID]);

  const handleAddCity = async () => {
    try {
      setLoading(true)
      await postApi(API_ADD_CITY, {
        cityName: newCity,
        stateID: state.stateID,
        countryID: state.countryID
      });
      setLoading(false);
      setNewCity("");
      fetchCities();
    } catch (error) {
      console.error("Failed to add city:", error);
    }
  }
const submitHander = () => {
  if( isEmpty(formValues.venue_id) ){
      addVenueDetails();
  }else{
      updateVenueDetails();
  }
}


  async function updateVenueDetails() {
    try {
      setWarning({...warning, venueTypeError:isEmpty(venuetype.value), venueCountryError : isEmpty(venuecountry.value),venueStateError:isEmpty(venuestate.value) ,venueCityError:isEmpty(venuecity.value)  })
      
   
       if(!isEmpty(state.cityID)){ setWarning({...warning, venueCityError:false  });    }
      if(isEmpty(state.cityID)){toast.error("Please select the City "); return;}
     
      if(isEmpty(formValues.venuemobileno.value)){toast.error("mobile Number is not valid"); return;}
      // if(isEmpty(formValues.venueaddress.value)){toast.error("Please Enter Address"); return;}
      if(isEmpty(formValues.venuepincode.value)){toast.error("Please Enter Pincode"); return;}
      // if(isEmpty(formValues.businesslabel.value)){toast.error("Please Enter GST/Business Label"); return;}
      if(isEmpty(formValues.venueemail.value)){toast.error("Please Enter Email Address"); return;}
      
     
      setLoading(true)
      const obj = {
        "user_id":formValues.user_id,
        "venue_id":formValues.venue_id,
        "venue_name":formValues.venuename.value,
        "venue_type":formValues.venuetype.value === "Others" ?state.customVenueType : formValues.venuetype.value,
        "country_code":state.countryCode,
        "venue_mobile_no":formValues.venuemobileno.value,
        "venue_email":formValues.venueemail.value,
        "currency":state.currency,
        "country":state.countryID,
        "state":state.stateID,
        "city":state.cityID,
        "address":formValues.venueaddress.value,
        "pincode":formValues.venuepincode.value,
        "business_label":formValues.businesslabel.value,
        "business_number":formValues.businessnumber.value,
        "website_url":formValues.venuewebsiteurl.value
      }
    console.log("Obj",obj)
      const resp = await postApi(API_UPDATE_VENUE_REGISTRATION , obj);
      console.log("Submit Resp:",resp);
      setLoading(false);
      if(resp.status_code === 200){
        handleNext();
      }else{
        toast.error("Registration failed")
      }

    } catch (error) {
      setLoading(false)
      console.error("Error :", error);
    }
  }


  async function addVenueDetails() {
    try {
      // if(isEmpty(formValues.venuetype.value)){   setWarning({...warning, venueTypeError : true})}
      // if(isEmpty(formValues.venuecountry.value)){   setWarning({...warning, venueCountryError : true})}
      console.log("Warning:",warning);
      setWarning({...warning, venueTypeError:isEmpty(venuetype.value), venueCountryError : isEmpty(venuecountry.value),venueStateError:isEmpty(venuestate.value) ,venueCityError:isEmpty(venuecity.value)  })
      
   
       if(!isEmpty(state.cityID)){ setWarning({...warning, venueCityError:false  });    }
      if(isEmpty(state.cityID)){toast.error("Please select the City "); return;}
     
      if(isEmpty(formValues.venuemobileno.value)){toast.error("mobile Number is not valid"); return;}
      // if(isEmpty(formValues.venueaddress.value)){toast.error("Please Enter Address"); return;}
      if(isEmpty(formValues.venuepincode.value)){toast.error("Please Enter Pincode"); return;}
      // if(isEmpty(formValues.businesslabel.value)){toast.error("Please Enter GST/Business Label"); return;}
      if(isEmpty(formValues.venueemail.value)){toast.error("Please Enter Email Address"); return;}
      
     
      setLoading(true)
      const obj = {
        "user_id":formValues.user_id,
        "venue_name":formValues.venuename.value,
        "venue_type":formValues.venuetype.value === "Others" ?state.customVenueType : formValues.venuetype.value,
        "country_code":state.countryCode,
        "venue_mobile_no":formValues.venuemobileno.value,
        "venue_email":formValues.venueemail.value,
        "currency":state.currency,
        "country":state.countryID,
        "state":state.stateID,
         "city":state.cityID,
        "address":formValues.venueaddress.value,
        "pincode":formValues.venuepincode.value,
        "business_label":formValues.businesslabel.value,
        "business_number":formValues.businessnumber.value,
        "website_url":formValues.venuewebsiteurl.value
      }
    console.log("Obj",obj)
      const resp = await postApi(API_VENUE_REGISTRATION,obj);
      console.log("Submit Resp:",resp);
      setLoading(false)
      if(resp.status_code === 200){
        const venueID = resp.data?.data;
        formValues.venue_id = venueID;
        handleNext();
      }else{
        toast.error("Registration failed")
      }

    } catch (error) {
      setLoading(false)
      console.error("Error :", error);
    }
  }


  return (
  <Box sx={{ ...VM_ResponsiveBox, ...registrationStepShellSx }}>
      <Box sx={{}}>
        <TitleDesc title={VENUE_REGISTRATION} subtitle={ADD_VENUE_DETAILS_BELOW} />

        <Grid container spacing={2} sx={{ width: '100%', maxWidth: 1200, mx: 'auto' }} mt={5}>

          <Grid item xs={12} md={4} >
            <Box >
              <FieldWrapper>
              <StyledInputField
                heading="Venue Name"
                name="venuename"
                  placeholder="Enter Your Venue Name"
                  variant={variant}
                  value={venuename.value}
                  onChange={(e) =>
                    handleChange({
                      target: {
                        name: e.target.name,
                        value: toTitleCaseInput(e.target.value),
                      },
                    })
                  }
                  error={!!venuename.error}
                  helperText={venuename.error}
                  required={venuename.required}
                  fullWidth
              />
              </FieldWrapper>
            </Box>
          </Grid>

          <Grid item xs={12} md={4} >
            
              <FieldWrapper>
              <MuiTypographyMandatory label="Venue Type" required />
              <MUITextFieldSelect
              name={Venue_Type}
              id={Venue_Type}
              required 
              value={venuetype.value}
              error={warning.venueTypeError}
              onChange={(e) => { 
                 const selected = e.target.value; 
                 if (selected !== 'Others') {
                  setState({...state,customVenueType:''})
                }
                venuetype.value = selected;  
                setWarning({...warning, venueTypeError : false})  
              }}
              options={VM_venueTypes}
              sx={{width:'100%',mt:0.5}}
            />
            </FieldWrapper>
            
          </Grid>
        {venuetype.value === 'Others' && (
          <Grid item xs={12}>
            <FieldWrapper>
            <StyledInputField
              heading="Add Venue Type"
              placeholder="Enter Custom Venue Type"
              fullWidth
                value={state.customVenueType}
                onChange={(e) =>  setState({...state,customVenueType:e.target.value }) }
                required
            />
          </FieldWrapper>
          </Grid>
        )}

          <Grid item xs={12} md={4}>
            <FieldWrapper>
            <StyledInputField
              heading= {  isEmpty(state.countryCode)? "Venue Mobile no " : "Venue Mobile no  (+"+state.countryCode+")"}
              name="venuemobileno"
              placeholder={"Enter Your Mobile Number"}
              variant={variant}
              value={state.venuemobileno}
              onChange={(e) => { 
                let inputValue = e.target.value.replace(/\D/g, ''); // Keep only digits
                if (inputValue.length > 10) {
                  inputValue = inputValue.slice(0, 10); // Limit to 10 digits
                }
                venuemobileno.value = inputValue;
                setState({  ...state, venuemobileno:  venuemobileno.value})
             }}
              error={!!venuemobileno.error}
              helperText={venuemobileno.error}
              required={venuemobileno.required}
              fullWidth
              inputProps={{ maxLength: 15, inputMode: 'numeric', pattern: '[0-9]*' }}
            
            />
            </FieldWrapper>
          </Grid>

          <Grid item xs={12} md={4}>
            <FieldWrapper>
             <Stack spacing={0.2}>
              <MuiTypographyMandatory label="Country" required />
              <MUITextFieldSelect
              name={Venue_Country}
              id={Venue_Country}
              required
               value={ formValues.venuecountry.value }
              error={warning.venueCountryError}
              onChange={(e) => { 
                const CID = e.target.value;
                formValues.venuecountry.value = CID;
                formValues.venuestate.value = "";
                const currency  = getCurrencyFromCountryID(country, CID);
                const countryCode  = getCountryCodeFromCountryID(country, CID);
                setState({...state, countryID: CID, currency, countryCode, stateID: "", cityID: ""});
                setCitiesList([]);
                setWarning({...warning, venueCountryError: false});
              }}
              options={VM_transformCountryList(country)}
              sx={formFieldSpacing}
            />
            </Stack>
            </FieldWrapper>
          </Grid>

          <Grid item xs={12} md={4}>
            <FieldWrapper>
            <Stack spacing={0.2}>
              <MuiTypographyMandatory label="State" required />
              <MUITextFieldSelect
              name={Venue_State}
              id={Venue_State}
              required
              placeholder="Select Your State"
              value={formValues.venuestate.value}
              error={warning.venueStateError}
              options={VM_transformStatesList(statesList)}
              onChange={(e) => { 
                if(isEmpty(venuecountry.value)){
                  toast.error("Please Select Country");
                  return
                }
                const SID = e.target.value;
                formValues.venuestate.value = SID;
                setState({...state,stateID: SID })
                setWarning({...warning,venueStateError:false})
              }}
              fullWidth
              sx={formFieldSpacing}
            />
            </Stack>
            </FieldWrapper>
          </Grid>

       

         <Grid item xs={12} md={4}>
          <FieldWrapper>
           <Stack spacing={0.2}>
           <MuiTypographyMandatory label="City" required />
             
          <Autocomplete
            name={Venue_City}
            id={Venue_City}
            options={Array.isArray(citiesList) ? citiesList : []}
            disableClearable
            getOptionLabel={(option) => option.city || ""}
            value={citiesList.find((city) => String(city.id) === String(state.cityID)) || null}
            onChange={(e, newValue) => {
              if (newValue) {
                setState({ ...state, cityID: newValue.id });
                formValues.venuecity.value = newValue.city;
              } else {
                setState({ ...state, cityID: null });
                formValues.venuecity.value = "";
              }
              setWarning({ ...warning, venueCityError: false });
            }}
            noOptionsText={
              <Box
                sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 2, py: 1 }}
                onClick={() => {
                  if (isEmpty(venuestate.value)) {
                    toast.error("Please Select State");
                    return;
                  }
                  setOpenDialog(true);
                }}
              >
                <AddLocationAltIcon fontSize="small" color="primary" />
                <Typography variant="body2" color="textSecondary">
                  No city found. Add new city
                </Typography>
              </Box>
            }
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select Your City"
                fullWidth
                error={warning.venueCityError}
              />
            )}
            sx={formFieldSpacing}
            style={{ minWidth: '200px' }}
          />
       </Stack>
       </FieldWrapper>
    </Grid>

          <Grid item xs={12} md={4}>
            <FieldWrapper>
           <StyledInputField
              heading="Address"
              name="venueaddress"   // ✅ THIS LINE IS IMPORTANT
              placeholder="Venue Address"
              variant={variant}
              value={venueaddress.value}
              onChange={handleChange}
              error={!!venueaddress.error}
              helperText={venueaddress.error}
              required={venueaddress.required}
              fullWidth
              style={formFieldSpacing}
            />
            </FieldWrapper>
          </Grid>
          <Grid item xs={12} md={4}>
            <FieldWrapper>
            <StyledInputField
              heading="Enter Pincode"
              placeholder="Enter Pincode"
              name="venuepincode"
              variant={variant}
              value={venuepincode.value}
              onChange={handleChange}
              error={!!venuepincode.error}
              helperText={venuepincode.error}
              required={venuepincode.required}
              fullWidth
              style={formFieldSpacing}
              inputProps={{ maxLength: 6 }}
            />
          </FieldWrapper>
          </Grid>

          <Grid item xs={12} md={4}>
            <FieldWrapper>
             <StyledInputField
              heading="GSTIN/PAN/VAT/Business Label"
              placeholder="GSTIN/PAN/VAT/Business Label"
              name="businesslabel"
              variant={variant}
              value={businesslabel.value}
              onChange={handleChange}
              error={!!businesslabel.error}
              helperText={businesslabel.error}
              required={businesslabel.required}
              fullWidth
              style={formFieldSpacing}
              />
            </FieldWrapper>
          </Grid>

      {/* Email */}
      <Grid item xs={12} md={4}>
        <FieldWrapper>
        <StyledInputField
          heading="Email"
          name="venueemail"
          variant={variant}
          placeholder="Your email address"
          type="email"
          value={venueemail.value}
          onChange={handleChange}
          error={!!venueemail.error}
          helperText={venueemail.error}
          required={venueemail.required}
          fullWidth
        />
        </FieldWrapper>
      </Grid>

        

          <Grid item xs={12} md={4}>
            <FieldWrapper>
             <StyledInputField
              heading= { "Website Url (Optional)"}
              name="venuewebsiteurl"
              placeholder={"Enter Website Url"}
              variant={variant}
              value={venuewebsiteurl.value}
              onChange={handleChange}
              style={formFieldSpacing}
              fullWidth 
            
            />
            </FieldWrapper>
          </Grid>

        </Grid>
        {
          !openDialog 
          ?  null
          :  <AddPopUP
                  isDisplay={openDialog}
                  title={
                    <MUITypography label="Add New City" />
                  }
                  renderBody ={ <TextField
                            autoFocus
                            margin="dense"
                            label="City Name"
                            fullWidth
                            variant="outlined"
                            value={newCity}
                            onChange={(e) => setNewCity(e.target.value)}
                          />}
                  renderActionButton = {
                    <Box sx={{ paddingRight: 2, display: "flex", justifyContent: "center" }}>
                      <Button
                        sx={{ mr: 2 }} // margin-right between buttons
                        onClick={() => 
                        {
                          setNewCity("");
                          setOpenDialog(false);
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        onClick={() => {
                          setNewCity("");
                          setOpenDialog(false);
                          handleAddCity();
                        }}
                        variant="contained"
                        disabled={!newCity.trim()}
                      >
                        Add
                      </Button>
                    </Box>
                  }        
                />
        }

 <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        p: 2,
        display: "flex",
        justifyContent: "center",
        backgroundColor: VM_Colors.white,
        borderTop: "1px solid #e0e0e0",
        zIndex: 1200,
      }}
    >
      {/* <Button onClick={handleBack} variant="outlined" sx={{ mr: 2 }}>
        Back
      </Button> */}
      <Button variant="contained" onClick={submitHander}>
        Next
      </Button>
    </Box>


      </Box>
      {
        loading ? <Loader loading={loading} /> : null 
      }
    </Box>
  );
}

export default VenueRegistration;
